// Mock data for Pauline Hotels

export const mockBookings = [];

export const mockInquiries = [];

export const heroImages = [
  'https://customer-assets.emergentagent.com/job_premiumlodging/artifacts/sibf2w6i_1.JPG',
  'https://customer-assets.emergentagent.com/job_premiumlodging/artifacts/cxxz0kz3_2.JPG',
  'https://customer-assets.emergentagent.com/job_premiumlodging/artifacts/habb3put_3.JPG',
  'https://customer-assets.emergentagent.com/job_premiumlodging/artifacts/276c655b_4.JPG',
  'https://customer-assets.emergentagent.com/job_premiumlodging/artifacts/chzo35cg_5.JPG'
];

export const roomCategories = [
  {
    id: 'standard',
    name: 'Standard Room',
    description: 'Thoughtfully designed for comfort and convenience, our Standard Rooms offer a perfect retreat for both business and leisure travelers.',
    size: '28 sqm',
    guests: '2 adults',
    amenities: [
      'High-speed Wi-Fi',
      'Flat Screen Television',
      'Work desk and ergonomic chair',
      'Premium bathroom amenities',
      'Tea and coffee facilities',
      'Daily housekeeping'
    ],
    images: [
      'https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=800&q=80',
      'https://images.unsplash.com/photo-1618773928121-c32242e63f39?w=800&q=80'
    ]
  },
  {
    id: 'executive',
    name: 'Executive Room',
    description: 'Elevated comfort meets sophisticated design. Our Executive Rooms provide extra space and premium amenities for discerning guests.',
    size: '38 sqm',
    guests: '2 adults + 1 child',
    amenities: [
      'All Standard Room amenities',
      'Premium bedding and linens',
      'Priority check-in/check-out'
    ],
    images: [
      'https://images.unsplash.com/photo-1590490360182-c33d57733427?w=800&q=80',
      'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=800&q=80'
    ]
  },
  {
    id: 'royal',
    name: 'Royal Suite',
    description: 'The pinnacle of luxury and exclusivity. Our Royal Suite offers an unparalleled experience for VIP guests seeking the finest accommodations.',
    size: '68 sqm',
    guests: '4 adults',
    amenities: [
      'All Executive Room amenities',
      'Separate seating area',
      'Bedroom with king size bed',
      'Balcony',
      'Complimentary spa treatment'
    ],
    images: [
      'https://images.unsplash.com/photo-1578683010236-d716f9a3f461?w=800&q=80',
      'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=800&q=80'
    ]
  }
];

export const menuCategories = [
  {
    name: 'Breakfast',
    items: [
      { name: 'Continental Breakfast', description: 'Fresh pastries, fruits, yogurt, cereals', price: '$18' },
      { name: 'Full English Breakfast', description: 'Eggs, bacon, sausages, mushrooms, tomatoes, toast', price: '$24' },
      { name: 'Healthy Start', description: 'Avocado toast, smoothie bowl, fresh juice', price: '$22' }
    ]
  },
  {
    name: 'Starters',
    items: [
      { name: 'Caesar Salad', description: 'Crisp romaine, parmesan, croutons, classic dressing', price: '$16' },
      { name: 'Soup of the Day', description: 'Chef\'s special creation with fresh bread', price: '$14' },
      { name: 'Bruschetta Trio', description: 'Tomato basil, mushroom, olive tapenade', price: '$18' }
    ]
  },
  {
    name: 'Main Courses',
    items: [
      { name: 'Grilled Salmon', description: 'Atlantic salmon, seasonal vegetables, lemon butter sauce', price: '$38' },
      { name: 'Beef Tenderloin', description: 'Prime beef, truffle mash, red wine reduction', price: '$48' },
      { name: 'Vegetarian Risotto', description: 'Arborio rice, seasonal vegetables, parmesan', price: '$28' },
      { name: 'Pan-Seared Chicken', description: 'Free-range chicken breast, herb jus, roasted potatoes', price: '$32' }
    ]
  },
  {
    name: 'Desserts',
    items: [
      { name: 'Chocolate Lava Cake', description: 'Warm chocolate cake, vanilla ice cream', price: '$14' },
      { name: 'Crème Brûlée', description: 'Classic French custard with caramelized sugar', price: '$12' },
      { name: 'Fresh Fruit Platter', description: 'Seasonal fruits, berry coulis', price: '$10' }
    ]
  },
  {
    name: 'Beverages',
    items: [
      { name: 'Freshly Brewed Coffee', description: 'Espresso, Americano, Cappuccino, Latte', price: '$5-7' },
      { name: 'Premium Teas', description: 'Selection of black, green, herbal teas', price: '$6' },
      { name: 'Fresh Juices', description: 'Orange, apple, grapefruit, mixed berry', price: '$8' },
      { name: 'Soft Drinks', description: 'Coca-Cola, Sprite, Mineral Water', price: '$4' }
    ]
  },
  {
    name: 'Cocktails & Bar',
    items: [
      { name: 'Signature Martini', description: 'Premium vodka or gin, dry vermouth, olive', price: '$16' },
      { name: 'Mojito', description: 'White rum, mint, lime, soda', price: '$14' },
      { name: 'Old Fashioned', description: 'Bourbon, bitters, sugar, orange', price: '$18' },
      { name: 'House Wine', description: 'Red, White, Rosé by the glass', price: '$12-16' }
    ]
  }
];

export const wellnessFacilities = [
  {
    id: 'gym',
    name: 'Gym',
    description: 'State-of-the-art gym equipped with the latest cardio and strength training equipment. Open for hotel guests.',
    features: [
      'Treadmills and ellipticals',
      'Free weights and resistance machines',
      'Yoga and stretching area',
      'Personal training available',
      'Complimentary water and towels'
    ],
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80'
  },
  {
    id: 'sauna',
    name: 'Sauna',
    description: 'Traditional Finnish sauna providing dry heat therapy to relax muscles, improve circulation, and promote detoxification.',
    features: [
      'Temperature-controlled environment',
      'Eucalyptus aromatherapy',
      'Private changing facilities',
      'Shower amenities provided'
    ],
    image: 'https://images.unsplash.com/photo-1583416750470-965b2707b355?w=800&q=80'
  },
  {
    id: 'steam',
    name: 'Steam Room',
    description: 'Luxurious steam room offering moist heat therapy to open pores, cleanse skin, and provide deep relaxation.',
    features: [
      'Humidity-controlled chamber',
      'Herbal steam infusions',
      'Comfortable seating',
      'Post-steam cooling area'
    ],
    image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&q=80'
  }
];

export const wellnessServices = [
  {
    name: 'Swedish Massage',
    description: 'Classic full-body massage using gentle to firm pressure to ease muscle tension and promote relaxation.',
    price: 'UGX 30,000'
  },
  {
    name: 'Deep Tissue Massage',
    description: 'Therapeutic massage targeting deep muscle layers to relieve chronic tension and pain.',
    price: 'UGX 30,000'
  },
  {
    name: 'Aromatherapy Massage',
    description: 'Relaxing massage combined with essential oils to enhance physical and emotional wellbeing.',
    price: 'UGX 30,000'
  },
  {
    name: 'Body Scrub & Wrap',
    description: 'Exfoliating treatment followed by nourishing body wrap to rejuvenate and hydrate skin.',
    price: 'UGX 30,000'
  }
];

export const hotelInfo = {
  name: 'Pauline Hotels',
  tagline: 'Comfort, Elegance, and Exceptional Service',
  address: 'Plot 7B, Dokolo Road, Senior Quarters, Lira City, Uganda',
  phone: '0779203214 / 0785662992 / 0766529199',
  email: 'paulinehotels@yahoo.com',
  reservationsEmail: 'paulinehotels@yahoo.com',
  supportEmail: 'paulinehotels@yahoo.com',
  mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.2!2d32.9!3d2.2!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMsKwMTInMDAuMCJOIDMywrA1NCcwMC4wIkU!5e0!3m2!1sen!2s!4v1234567890',
  socialMedia: {
    facebook: '#',
    instagram: '#',
    twitter: '#',
    linkedin: '#'
  }
};

export const whyChooseUs = [
  {
    title: 'Prime Location',
    description: 'Situated in the heart of the city with easy access to business districts and attractions',
    icon: 'MapPin'
  },
  {
    title: 'Exceptional Comfort',
    description: 'Luxuriously appointed rooms and suites designed for your ultimate relaxation',
    icon: 'Bed'
  },
  {
    title: 'Quality Service',
    description: '24/7 professional staff dedicated to making your stay memorable',
    icon: 'Award'
  },
  {
    title: 'Wellness Facilities',
    description: 'Complete health club with gym, sauna, steam room, and spa services',
    icon: 'Dumbbell'
  },
  {
    title: 'Fine Dining',
    description: 'Exquisite culinary experiences prepared by our expert chefs',
    icon: 'UtensilsCrossed'
  },
  {
    title: 'Secure Parking',
    description: 'Large parking lot with 24-hour security for your peace of mind',
    icon: 'Car'
  }
];

// Mock submission handlers
export const submitBooking = (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      mockBookings.push({
        ...bookingData,
        id: Date.now(),
        timestamp: new Date().toISOString()
      });
      console.log('Mock Booking Submitted:', bookingData);
      resolve({ success: true, message: 'Booking request submitted successfully!' });
    }, 1000);
  });
};

export const submitInquiry = (inquiryData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      mockInquiries.push({
        ...inquiryData,
        id: Date.now(),
        timestamp: new Date().toISOString()
      });
      console.log('Mock Inquiry Submitted:', inquiryData);
      resolve({ success: true, message: 'Your inquiry has been submitted successfully!' });
    }, 1000);
  });
};